import { Tooltip, TooltipContent, TooltipTrigger } from '@/platform/ui';
import {
    CheckCircleIcon,
    CheckIcon,
    EnvelopeIcon,
    ExclamationTriangleIcon,
} from '@heroicons/react/24/outline';
import { router } from '@inertiajs/react';
import { useState } from 'react';

const OnboardingIcon = ({ invitee }) => {
    const [inviteSent, setInviteSent] = useState(false);

    const resendInvite = () => {
        router.post(
            `/customers/${invitee.customer_id}/datahub-invitees/${invitee.id}/resend`,
            {},
            {
                preserveState: true,
                preserveScroll: true,
                replace: true,
                onSuccess: () => setInviteSent(true),
            }
        );
    };

    if (invitee.onboarding_done) {
        return (
            <Tooltip>
                <TooltipTrigger asChild>
                    <CheckIcon className='inline-flex size-5 text-green-600' />
                </TooltipTrigger>
                <TooltipContent>
                    Deze gebruiker heeft de onboarding in de Datahub succesvol
                    afgerond.
                </TooltipContent>
            </Tooltip>
        );
    }

    if (!invitee.onboarding_url) {
        return (
            <Tooltip>
                <TooltipTrigger asChild>
                    <ExclamationTriangleIcon className='inline-flex size-5 text-red-600' />
                </TooltipTrigger>
                <TooltipContent>
                    Voor deze gebruiker is geen onboarding-URL beschikbaar.
                    <br />
                    <br /> Er kan daarom geen uitnodiging worden verzonden.
                </TooltipContent>
            </Tooltip>
        );
    }

    return (
        <Tooltip>
            <TooltipTrigger
                onClick={() => (inviteSent ? null : resendInvite())}
            >
                {inviteSent ? (
                    <CheckCircleIcon className='inline-flex size-5 text-orange-600' />
                ) : (
                    <EnvelopeIcon className='size-5 cursor-pointer' />
                )}
            </TooltipTrigger>
            <TooltipContent>
                Deze gebruiker heeft de onboarding nog niet afgerond.
                <br />
                <br /> Uitnodiging verzonden.
            </TooltipContent>
        </Tooltip>
    );
};

export default OnboardingIcon;
